module.exports = __webpack_public_path__ + "static/media/bannerP2.147a51fb.png";